export const TOKEN_PASSWORD_PLACEHOLDER = '********';

export * from '@netx/core-share-link/constants';

export enum SharedResourceMode {
	CONTRIBUTOR = 'contributor',
	FAVORITE = 'favorite',
	MANAGER = 'manager',
	VIEWER = 'viewer',
}
